/*
 * @Author: changcheng
 * @LastEditTime: 2023-06-12 11:41:27
 */
import { useState, useEffect, useCallback, useMemo } from "react";
import { Modal, Form, Space, Input, Image } from "antd";
import aliPay from "@/img/aliPay.png";
import weChatPay from "@/img/weChatPay.png";
import axios from "@/axios/axios";
import "./index.less";
import { ArrowLeftOutlined } from "@ant-design/icons";
let waitPayStatus: string | number | NodeJS.Timeout | null | undefined = null;
export const PayModal = (props: {
  showPayModal: boolean;
  setShowModal: (show: boolean) => void;
  commodityInfo: {
    productId: number;
    quantity: number;
    count: number;
  };
}) => {
  const { showPayModal, setShowModal, commodityInfo } = props;
  const { count } = commodityInfo;
  console.log("commodityInfo", commodityInfo);

  const [currnetPayType, setCurrentPayType] = useState("aliPay");
  const [payCode, setPayCode] = useState("");
  const [orderInfo, setOrderInfo] = useState<{
    productName: string;
    validDateRange: string;
    quantity: number;
    productPrice: number;
    creditValue: number;
  }>({} as any);
  const [invitationCode, setInvitationCode] = useState("");
  const getProduct = async () => {
    const { productId, quantity } = commodityInfo;
    const { data } = await axios.post(
      "/shop/front/ce/preview/purchase/product",
      {
        productId,
        quantity,
      }
    );
    setOrderInfo(data);
  };
  useEffect(() => {
    showPayModal && getProduct();
  }, [showPayModal]);
  /**
   * 微信支付
   */
  const payWechatOrder = async () => {
    const { productId, quantity, count } = commodityInfo;
    const { data } = await axios.post(
      "/shop/front/ce/pc/create/wetChat/pay/order",
      {
        productId,
        quantity: count,
        invitationCode,
      }
    );
    const { tradeNo, weChatPayQrCode } = data;
    setPayCode(weChatPayQrCode);
    searchWechatPayStatus(tradeNo);
  };
  /**查询微信支付状态 */
  const searchWechatPayStatus = (tradeNo: string) => {
    waitPayStatus = setInterval(async () => {
      const {
        data: { code },
      } = await axios.post(`/shop/front/ce/order/${tradeNo}/pay/status`);
      if (code === 0) {
        clearInterval(waitPayStatus as number);
        setPayCode("");
        // 订单列表重定向查询
        window.location.href = `${window.location.href}?fromType=wechatPay`;
        window.location.reload();
      }
    }, 3000);
  };
  /**
   * 支付宝支付
   */
  const payAliOrder = async () => {
    const { productId, quantity } = commodityInfo;
    const { data } = await axios.post(
      "/shop/front/ce/pc/create/ali/pay/order",
      {
        productId,
        quantity: count,
        invitationCode,
      }
    );
    const { orderNo } = data;
    const returnUrl = encodeURIComponent(
      `${window.location.href}?currentPayTradeNo=${orderNo}`
    );
    window.location.href = `https://api.imed.org.cn/order/createAliPayOrder?payType=ALI_PAY&tradeNo=${orderNo}&returnUrl=${returnUrl}&tradeType=NATIVE`;
  };
  return (
    <div>
      <Modal
        open={showPayModal}
        title="订单信息"
        onOk={() => {
          setShowModal(false);
          currnetPayType === "weChatPay" ? payWechatOrder() : payAliOrder();
        }}
        onCancel={() => {
          setShowModal(false);
        }}
      >
        <p>
          <Space>
            <span>商品名称：</span>
            <span>{orderInfo?.productName}</span>
          </Space>
        </p>
        <p>
          <Space>
            <span>学习卡有效期：</span>
            <span>{orderInfo?.validDateRange}</span>
          </Space>
        </p>
        <p>
          <Space>
            <span>学分数量：</span>
            <span>{orderInfo?.creditValue}</span>
          </Space>
        </p>
        <p>
          <Space>
            <span>购买数量：</span>
            <span>{count}</span>
          </Space>
        </p>
        <p>
          <Space>
            <span>应付金额：</span>
            <span>
              {(orderInfo?.productPrice as number) * commodityInfo.count}元
            </span>
          </Space>
        </p>
        <p>
          <Space>
            <span>邀请码：</span>
            <span>
              <Input
                placeholder="请输入邀请码"
                onChange={(e) => {
                  setInvitationCode(e.target.value);
                }}
              />
            </span>
          </Space>
        </p>
        <p>
          <Space
            style={{
              cursor: "pointer",
            }}
          >
            <span>选择支付方式：</span>
            <span
              className={currnetPayType == "aliPay" ? "add" : ""}
              onClick={() => {
                setCurrentPayType("aliPay");
              }}
            >
              <img src={aliPay} />
            </span>
            <span
              className={currnetPayType == "weChatPay" ? "add" : ""}
              onClick={() => {
                setCurrentPayType("weChatPay");
              }}
            >
              <img src={weChatPay} />
            </span>
          </Space>
        </p>
      </Modal>
      {payCode && (
        <div className="weChatPayModal">
          <p
            onClick={() => {
              clearInterval(waitPayStatus as number);
              setPayCode("");
            }}
            className="back"
          >
            <Space>
              <ArrowLeftOutlined />
              返回
            </Space>
          </p>
          <div className="content">
            <h3>微信支付</h3>
            <p>请扫描二维码付款</p>
            <p>
              ¥&nbsp;{(orderInfo?.productPrice as number) * commodityInfo.count}
            </p>
            <img src={payCode} alt="" />
          </div>
        </div>
      )}
    </div>
  );
};
